import { STREAM_PRIVACY_MASK } from '../config/streamPrivacy';
import { needsCanvasPrivacyMask } from '../utils/privacyMaskPlatform';

export function StreamPrivacyMask({ geometryOnly = needsCanvasPrivacyMask() }) {
    if (!STREAM_PRIVACY_MASK.enabled) return null;

    const { blur } = STREAM_PRIVACY_MASK;

    return (
        <div
            className={`stream-privacy-blur pointer-events-none absolute z-[12]${geometryOnly ? ' stream-privacy-blur--geometry' : ''}`}
            style={{
                left: blur.left,
                top: blur.top,
                width: blur.width,
                height: blur.height,
            }}
            aria-hidden
        />
    );
}
